import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'
import './assets/iconfont/iconfont.css'
import './assets/css/animate.css'
import './assets/css/common.css'
import registryAlert from '@/components/Alert'

function isPhone () {
    let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return mobile!= null
}

if (isPhone()) {
    let url = location.href
    if (url.indexOf("www.rcclchina.com.cn") >= 0) {
        url = url.replace('www.rcclchina.com.cn', 'mobile.rcclchina.com.cn')
    } 
    url = url.replace('/rewardpc/', '/reward/')
    location.href = url
} else {
    let url = location.href
    if (url.indexOf("mobile.rcclchina.com.cn") >= 0) {
        url = url.replace('mobile.rcclchina.com.cn', 'www.rcclchina.com.cn')
        location.href = url
    } 
}

Vue.use(registryAlert)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false

Vue.prototype.$config = config

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
